import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "asset-image-form" }
const _hoisted_4 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center gap-2 mb-4"
}
const _hoisted_5 = { class: "form-section" }
const _hoisted_6 = { class: "form-section-title" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "form-label required" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_13 = { class: "form-section" }
const _hoisted_14 = { class: "form-section-title" }
const _hoisted_15 = { class: "mb-3" }
const _hoisted_16 = ["aria-label"]
const _hoisted_17 = { class: "text-muted" }
const _hoisted_18 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_19 = {
  key: 1,
  class: "image-preview mt-2"
}
const _hoisted_20 = ["src"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_23 = { class: "form-section" }
const _hoisted_24 = { class: "form-section-title" }
const _hoisted_25 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_26 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_27 = {
  key: 2,
  class: "asset-image-grid"
}
const _hoisted_28 = { class: "image-preview" }
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "asset-image-actions" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "asset-image-footer" }
const _hoisted_33 = {
  key: 0,
  class: "delete-confirm"
}
const _hoisted_34 = ["disabled"]
const _hoisted_35 = ["disabled"]
const _hoisted_36 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    ref: "modalRef",
    nested: false,
    size: "lg"
  }, {
    header: _withCtx(() => [
      _createElementVNode("h4", null, [
        (_ctx.assetName)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t('components.assets.images.title')) + ": " + _toDisplayString(_ctx.assetName), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('components.assets.images.title')), 1))
      ])
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[8] || (_cache[8] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.errorMessage), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h5", _hoisted_6, [
            _cache[9] || (_cache[9] = _createElementVNode("i", { class: "bi bi-pencil-square me-2" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assets.images.nameTitle')), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('components.assets.images.nameLabel')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.assetNameInput) = $event)),
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.nameError }]),
              placeholder: _ctx.$t('components.assets.images.namePlaceholder')
            }, null, 10, _hoisted_9), [
              [_vModelText, _ctx.assetNameInput]
            ]),
            (_ctx.nameError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.nameError), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-primary btn-sm",
            disabled: _ctx.savingName,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveAssetName && _ctx.saveAssetName(...args)))
          }, [
            (_ctx.savingName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assets.images.nameSave')), 1)
          ], 8, _hoisted_11)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("h5", _hoisted_14, [
            _cache[10] || (_cache[10] = _createElementVNode("i", { class: "bi bi-image me-2" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assets.images.uploadTitle')), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("input", {
              id: "assetImage",
              ref: "imageInput",
              type: "file",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.imageError }]),
              accept: "image/jpeg,image/png,image/webp,image/gif",
              "aria-label": _ctx.$t('components.assets.images.fields.image'),
              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleImageChange && _ctx.handleImageChange(...args)))
            }, null, 42, _hoisted_16),
            _createElementVNode("small", _hoisted_17, _toDisplayString(_ctx.$t('components.assets.images.hints.image')), 1),
            (_ctx.imageError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.imageError), 1))
              : _createCommentVNode("", true),
            (_ctx.imagePreview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("img", {
                    src: _ctx.imagePreview,
                    alt: "Asset preview"
                  }, null, 8, _hoisted_20),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-remove-preview",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearImageSelection && _ctx.clearImageSelection(...args)))
                  }, [...(_cache[11] || (_cache[11] = [
                    _createElementVNode("i", { class: "bi bi-x-circle-fill" }, null, -1)
                  ]))])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            disabled: !_ctx.imageFile || _ctx.uploading,
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.uploadImage && _ctx.uploadImage(...args)))
          }, [
            (_ctx.uploading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_22))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assets.images.uploadAction')), 1)
          ], 8, _hoisted_21)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("h5", _hoisted_24, [
            _cache[12] || (_cache[12] = _createElementVNode("i", { class: "bi bi-images me-2" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assets.images.listTitle')), 1)
          ]),
          (_ctx.loadingImages)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "spinner-border spinner-border-sm me-2" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assets.images.loading')), 1)
              ]))
            : (_ctx.images.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.$t('components.assets.images.empty')), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: image.id,
                      class: "asset-image-card"
                    }, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("img", {
                          src: _ctx.convertPathToUrl(_ctx.getImagePath(image)),
                          alt: "Asset"
                        }, null, 8, _hoisted_29)
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-danger btn-sm",
                          onClick: ($event: any) => (_ctx.requestDelete(image))
                        }, [
                          _cache[14] || (_cache[14] = _createElementVNode("i", { class: "bi bi-trash me-1" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('common.remove')), 1)
                        ], 8, _hoisted_31)
                      ])
                    ]))
                  }), 128))
                ]))
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_32, [
        (_ctx.pendingDelete)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.images.deleteConfirm')), 1),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-secondary btn-sm",
                disabled: _ctx.deleting,
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cancelDelete && _ctx.cancelDelete(...args)))
              }, _toDisplayString(_ctx.$t('common.no')), 9, _hoisted_34),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-danger btn-sm",
                disabled: _ctx.deleting,
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
              }, [
                (_ctx.deleting)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_36))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.remove')), 1)
              ], 8, _hoisted_35)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, _toDisplayString(_ctx.$t('components.assets.images.close')), 1)
      ])
    ]),
    _: 1
  }, 512))
}